<script lang="ts">
    import {Button, InlineLoading, Select, SelectItem} from "carbon-components-svelte";
    import {selectedBuilding, selectedTenant, gates} from "../stores";
    import {Building} from "../models/Building";
    import type {Tenant} from "../models/Tenant";
    import { onMount } from "svelte";
    import type {Requests} from "../libreries/Requests";

    export let requests: Requests;
    $: building = new Building(); //support variable to get the item selected from selected
    let buildings: Building[] = [];
    let tenant: Tenant;
    let promise: Promise<any>;

    onMount(() => {
        selectedTenant.subscribe((value) =>{
            tenant = value;
        })
        selectedBuilding.subscribe((value) => {
            if(value){
                building = value;
            }else{
                building = new Building();
            }
        })
        if(buildings.length === 0){
            promise = getBuildings();
        }
    })

    async function getBuildings(){
        buildings = await requests.getBuildings(tenant.id);
    }

    function getBuilding(){
        selectedBuilding.change(buildings.find(x => x.id === building.id));
        getGates();
    }

    async function getGates(){
        gates.set(await requests.getGates(tenant.id, building.id));
    }
</script>

{#await promise}
    <InlineLoading />
{:then}
    <div style="display:flex; justify-content: start; align-items: flex-end;">
        <div>
            <Select labelText="Seleziona building" bind:selected={building.id} >
                <SelectItem value={building.id} text="Seleziona un building" disabled hidden />
                {#each buildings as item }
                <SelectItem value={item.id} text={item.name} />
                {/each}
            </Select>
        </div>
        <div style="margin-left: 3rem;">
            <Button on:click={getBuilding}>Carica</Button>
        </div>
    </div>
{/await}